import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import PersonFactory from "../../Entity/Factories/PersonFactory";

export default function* personList(action: ActionInterface): any {
  try {
    const res = yield call(Http.get, "contacts");

    // Iterate through each raw person data and convert them to objects.
    const persons = res.data.persons.map(person => {
      return PersonFactory.create(person);
    });

    yield put({
      type: Constants.GLOBAL_PERSON_LIST_SUCCESS,
      payload: {
        persons: persons
      }
    });

  } catch (err) {
    // should signout user if entity could not be loaded
    yield put({
      type: Constants.PAGE_SIGNOUT_START
    });
    
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchPersonList() {
  yield takeEvery(Constants.GLOBAL_PERSON_LIST, personList);
}
